import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PERMISSIONCATEGORY,
  DELETE_PERMISSIONCATEGORY,
  UPDATE_PERMISSIONCATEGORY,
  ADD_NEW_PERMISSIONCATEGORY,
} from "./actionType";

import {
  getPermissionCategorySuccess,
  getPermissionCategoryFail,
  deletePermissionCategorySuccess,
  deletePermissionCategoryFail,
  updatePermissionCategorySuccess,
  updatePermissionCategoryFail,
  addPermissionCategorySuccess,
  addPermissionCategoryFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getPermissionCategoryApi,
  updatePermissionCategoryApi,
  deletePermissionCategoryApi,
  addNewPermissionCategoryApi
} from "../../helpers/backend_helper";

function* getPermissionCategory({ payload: permissionCategory }) {
  try {
    const response = yield call(getPermissionCategoryApi, permissionCategory);
    yield put(getPermissionCategorySuccess(GET_PERMISSIONCATEGORY, response.data));
  } catch (error) {
    yield put(getPermissionCategoryFail(GET_PERMISSIONCATEGORY, error));
  }
}

function* onUpdatePermissionCategory({ payload: permissionCategory }) {
  try {
    const response = yield call(updatePermissionCategoryApi, permissionCategory);
    yield put(updatePermissionCategorySuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updatePermissionCategoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeletePermissionCategory({ payload: permissionCategory }) {
  try {
    const response = yield call(deletePermissionCategoryApi, permissionCategory);
    yield put(deletePermissionCategorySuccess({ permissionCategory, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deletePermissionCategoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewPermissionCategory({ payload: permissionCategory }) {
  try {
    const response = yield call(addNewPermissionCategoryApi, permissionCategory);
    yield put(addPermissionCategorySuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addPermissionCategoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetPermissionCategory() {
  yield takeEvery(GET_PERMISSIONCATEGORY, getPermissionCategory);
}

export function* watchUpdatePermissionCategory() {
  yield takeEvery(UPDATE_PERMISSIONCATEGORY, onUpdatePermissionCategory);
}

export function* watchDeletePermissionCategory() {
  yield takeEvery(DELETE_PERMISSIONCATEGORY, onDeletePermissionCategory);
}

export function* watchAddNewPermissionCategory() {
  yield takeEvery(ADD_NEW_PERMISSIONCATEGORY, onAddNewPermissionCategory);
}

function* permissionCategorySaga() {
  yield all([
    fork(watchGetPermissionCategory),
    fork(watchDeletePermissionCategory),
    fork(watchUpdatePermissionCategory),
    fork(watchAddNewPermissionCategory)
  ]);
}

export default permissionCategorySaga;
